export default __webpack_public_path__ + "static/media/Background_00129.a9f3af45.png";